// @flow
import { connect } from 'react-redux';
import { changePasswordRequest } from 'redux/User/actions';
import { getChangePasswordError, getChangePasswordSuccess, getUserName } from 'redux/User/selectors';
import ChangePassword, { type DispatchPropsType } from './ChangePassword.component';

const mapStateToProps = (state: StoreType): DashboardStore => ({
  changePasswordSuccess: getChangePasswordSuccess(state),
  changePasswordError: getChangePasswordError(state),
  getUserName: getUserName(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  changePassword: (payload) => dispatch(changePasswordRequest(payload)),
});

export default (connect(mapStateToProps, mapDispatchToProps)(ChangePassword): any);
